import { setEmptyStream, setIsLastStream, storeEmojiIcons, storeProjectStreams, storeTotalDraftStreams } from "../../actions/projects";
import { setAliasName, setAllSuperAdminTableData, setSuperAdminWidgetData } from "../../actions/superAdmin";
import { notifyIcon, requestMethod } from "../../config";
import config from "../../env.config";
import { fetch } from "../../shared/services/api.service";
import { saveState } from "../../shared/services/session.service";
import { getNotification } from "../../utils/common";
import { checkApiSuccess } from "../../utils/index";

/**
 * handle api for super admin data
 * @param {Void}
 * @returns {Void}
 */
export const getSuperAdminData = () => {
  return async (dispatch) => {
    let requestConfig = {
      method: requestMethod.GET,
      url: `${config.BASE_URL.BASE_API_URL}/superadmin/getData`,
    };

    let response = await fetch(requestConfig, true, false);
    if (checkApiSuccess(response)) {
      const { activeUser, companyTable, inActiveUser, numberOfOrg, numberOfProject, numberOfTask, numberOfTeam } = response.data.data;
      dispatch(setSuperAdminWidgetData({ activeUser, inActiveUser, numberOfOrg, numberOfProject, numberOfTask, numberOfTeam }));
      dispatch(setAllSuperAdminTableData(companyTable));
    }
  };
};

export const getSuperAdminStream = (payload) => {
  return async (dispatch) => {
    const requestConfig = {
        method: requestMethod.GET,
        url: `${config.BASE_URL.BASE_API_URL}/superadmin/getSuperAdminStream`,
        params: payload,
      },
      response = await fetch(requestConfig, true, false);
    if (checkApiSuccess(response)) {
      if (response.data.data?.stream?.length) {
        dispatch(storeProjectStreams(response.data.data.stream));
      } else {
        dispatch(setIsLastStream(true));
        dispatch(setEmptyStream(true));
      }
      dispatch(storeEmojiIcons(response.data.data.emojiList));
      dispatch(storeTotalDraftStreams(response.data.data.totalDraftStreams));
      dispatch(setAliasName(response.data.data.superAdminAliasName));
    }
    return response?.data?.data;
  };
};

export const updateVersionNo = (payload) => {
  return async (dispatch) => {
    const requestConfig = {
        method: requestMethod.POST,
        url: `${config.BASE_URL.BASE_API_URL}/superadmin/updateVersionNo`,
        data: payload,
      },
      response = await fetch(requestConfig, true, false);
    if (checkApiSuccess(response)) {
      saveState("version", payload.versionNo);
    }
  };
};

/**
 * Get organization/company feature list for super admin
 * @param {*} companyId
 * @returns
 * @author Ankit Negi
 */
export const getSuperAdminOrganization = async (companyId) => {
  const requestConfig = {
    method: requestMethod.GET,
    url: `${config.BASE_URL.BASE_API_URL}/superadmin/getSuperAdminOrganization`,
    params: { companyId },
  };
  const response = await fetch(requestConfig, false, false);
  if (checkApiSuccess(response)) {
    return response.data.data;
  } else return null;
};

/**
 * Fetches fetaure list defaults (static data), which includes feature setting names and their respective IDs.
 * Additional feature settings may be added in the future so for improved data management at both frontend and backend made this api.
 * @param {*} userId
 * @returns
 * @author Ankit Negi
 */
export const getSuperAdminDefaults = async (userId) => {
  const requestConfig = {
    method: requestMethod.GET,
    url: `${config.BASE_URL.BASE_API_URL}/superadmin/getSuperAdminDefaults`,
    params: { userId },
  };
  const response = await fetch(requestConfig, false, false);
  if (checkApiSuccess(response)) {
    return response.data.data;
  } else return null;
};

/**
 * Update the feature list of a company in super admin
 * @param {Object} bodyData {companyId, featureId, isActive, userId}
 * @returns
 * @author Ankit Negi
 */
export const updateSuperAdminFeatureSetting = async (bodyData) => {
  const requestConfig = {
    method: requestMethod.POST,
    url: `${config.BASE_URL.BASE_API_URL}/superadmin/updateSuperAdminFeatureSetting`,
    data: bodyData,
  };
  const response = await fetch(requestConfig, false, false);
  if (checkApiSuccess(response)) {
    getNotification(response.data.message, notifyIcon.SUCCESS_ICON);
    return response.data.data;
  }
};

/**
 * Add chatbot attachment
 * @param {*} payload
 * @returns
 * @author Ankit Negi
 */
export const addChatbotAttachment = async ({ payload, userId }) => {
  const requestConfig = {
    method: requestMethod.POST,
    url: `${config.BASE_URL.BASE_API_URL}/superadmin/addChatbotAttachment`,
    params: { userId },
    data: payload,
  };
  const response = await fetch(requestConfig, false, false);
  if (checkApiSuccess(response)) {
    getNotification(response.data.message, notifyIcon.SUCCESS_ICON);
    return response.data.data;
  }
};

/**
 * Get chatbot attachments
 * param {*} userId
 * @returns
 * @author Ankit Negi
 */
export const getChatbotAttachment = async (userId) => {
  const requestConfig = {
    method: requestMethod.GET,
    url: `${config.BASE_URL.BASE_API_URL}/superadmin/getChatbotAttachment`,
    params: { createdBy: userId },
  };
  const response = await fetch(requestConfig, false, false);
  if (checkApiSuccess(response)) {
    return response.data.data;
  } else return null;
};

/**
 * Delete chatbot attachment
 * @param {*} payload
 * @returns
 * @author Ankit Negi
 */
export const deleteChatbotAttachment = async (attachmentId) => {
  const requestConfig = {
    method: requestMethod.PUT,
    url: `${config.BASE_URL.BASE_API_URL}/superadmin/deleteChatbotAttachment`,
    data: {
      attachmentId,
    },
  };
  const response = await fetch(requestConfig, false, false);
  if (checkApiSuccess(response)) {
    getNotification(response.data.message, notifyIcon.SUCCESS_ICON);
    return response.data.data;
  }
};

/**
 * Add chatbot prompt
 * @param {*} Object
 * @returns
 * @author Ankit Negi
 */
export const addPrompt = async ({ text, createdBy, type }) => {
  const requestConfig = {
    method: requestMethod.POST,
    url: `${config.BASE_URL.BASE_API_URL}/superadmin/addPrompt`,
    data: { text, createdBy, type },
  };
  const response = await fetch(requestConfig, false, false);
  if (checkApiSuccess(response)) {
    getNotification(response.data.message, notifyIcon.SUCCESS_ICON);
    return response.data.data;
  }
};

/**
 * Get chatbot prompt
 * param {*} createdBy
 * @returns
 * @author Ankit Negi
 */
export const getPrompt = async (type) => {
  const requestConfig = {
    method: requestMethod.GET,
    url: `${config.BASE_URL.BASE_API_URL}/superadmin/getPrompt`,
    params: { type },
  };
  const response = await fetch(requestConfig, false, false);
  if (checkApiSuccess(response)) {
    return response.data.data;
  } else return null;
};

/**
 * Update chatbot prompt
 * @param {*} Object
 * @returns
 * @author Ankit Negi
 */
export const updatePrompt = async ({ text, createdBy, promptId, type }) => {
  const requestConfig = {
    method: requestMethod.PUT,
    url: `${config.BASE_URL.BASE_API_URL}/superadmin/updatePrompt`,
    data: {
      text,
      createdBy,
      promptId,
      type,
    },
  };
  const response = await fetch(requestConfig, false, false);
  if (checkApiSuccess(response)) {
    getNotification(response.data.message, notifyIcon.SUCCESS_ICON);
    return response.data.data;
  }
};

/**
 * Get chat history for perticular org for super admin
 * @param {*} object,
 * @returns
 * @author Bhavana
 */
export const getChatHistory = async (data) => {
  const requestConfig = {
    method: requestMethod.POST,
    url: `${config.BASE_URL.BASE_API_URL}/admin/getChatHistory`,
    data: data,
  };
  const response = await fetch(requestConfig, false, false);
  if (checkApiSuccess(response)) {
    return response.data.data;
  } else return null;
};

export const getUserIdsForCompany = async (data) => {
  const requestConfig = {
    method: requestMethod.GET,
    url: `${config.BASE_URL.BASE_API_URL}/user/getUserIdsForCompany`,
    params: data,
  };
  const response = await fetch(requestConfig, false, false);
  if (checkApiSuccess(response)) {
    return response.data.data;
  } else return null;
};

export const getAdminStream = (payload) => {
  return async (dispatch) => {
    const requestConfig = {
        method: requestMethod.GET,
        url: `${config.BASE_URL.BASE_API_URL}/admin/getAdminStream`,
        params: payload,
      },
      response = await fetch(requestConfig, true, false);
    if (checkApiSuccess(response)) {
      if (response.data.data?.stream?.length) dispatch(storeProjectStreams(response.data.data.stream));
      else {
        dispatch(setIsLastStream(true));
        dispatch(setEmptyStream(true));
      }
      dispatch(storeEmojiIcons(response.data.data.emojiList));
      dispatch(storeTotalDraftStreams(response.data.data.totalDraftStreams));
    }
    return response?.data?.data;
  };
};
